import { registerTablesListeners } from 'redux/modules/table'
import { registerBarsListeners } from 'redux/modules/bar'
import { registerTransactionListeners } from 'redux/modules/transaction'
import { registerLockersListeners } from 'redux/modules/locker'
import { registerSettingsListeners } from 'redux/modules/settings'
import { registerPricingsListeners } from 'redux/modules/pricing'
import { registerPlayersListeners } from 'redux/modules/player'
import { registerCategoriesListeners } from 'redux/modules/category'
import { registerProductsListeners } from 'redux/modules/product'
import { registerUsersListeners } from 'redux/modules/user'
import { registerCustomersListeners } from 'redux/modules/customer'
import {
  registerAuthListeners,
  registerOnlineListeners
} from 'redux/modules/auth'

export function registerAuthListener(store) {
  registerAuthListeners(store)(store.dispatch, store.getState)
  registerOnlineListeners(store)(store.dispatch, store.getState)
}
export function registerAllListeners(dispatch, getState) {
  return (dispatch, getState) => {
    registerUsersListeners()(dispatch, getState)
    registerSettingsListeners()(dispatch, getState)
    registerTablesListeners()(dispatch, getState)
    registerBarsListeners()(dispatch, getState)
    registerTransactionListeners()(dispatch, getState)
    registerLockersListeners()(dispatch, getState)
    registerCategoriesListeners()(dispatch, getState)
    registerProductsListeners()(dispatch, getState)
    registerPricingsListeners()(dispatch, getState)
    registerPlayersListeners()(dispatch, getState)
    registerCustomersListeners()(dispatch, getState)
    // registerHistoryListeners()(dispatch, getState)
  }
}
export function unregisterAllListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    return new Promise((resolve, reject) => {
      firebase.child('hbUsers').off()
      firebase.child('tables').off()
      firebase.child('bars').off()
      firebase.child('transactions').off()
      firebase.child('lockers').off()
      firebase.child('categories').off()
      firebase.child('products').off()
      firebase
        .child('settings')
        .child('currentDates')
        .off()
      firebase
        .child('settings')
        .child('currentPricing')
        .off()
      firebase
        .child('settings')
        .child('size')
        .off()
      firebase
        .child('settings')
        .child('tableTypes')
        .off()
      firebase
        .child('settings')
        .child('chatEnabled')
        .off()
      firebase
        .child('settings')
        .child('taxes')
        .off()
      firebase
        .child('settings')
        .child('payments')
        .off()
      firebase
        .child('settings')
        .child('menu')
        .off()
      firebase.child('pricings').off()
      firebase.child('players').off()
      firebase.child('history').off()
      firebase.child('customers').off()
      return resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/registerListeners.js